import mainCaller from './mainCaller';
const qs = require('qs');

export const createSalary = async (data, token) => {
  return await mainCaller('admin/api/v1/employees/salaries', 'POST', data, {
    Authorization: `Bearer ${token}`,
    // 'Content-type': 'multipart/form-data',
  });
};

export const updateSalary = async (id, data, token) => {
  return await mainCaller(`admin/api/v1/employees/salaries/${id}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    // 'Content-type': 'multipart/form-data',
  });
};

export const getAllSalary = async (query, token) => {
  return await mainCaller(`admin/api/v1/employees/salaries?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};


export const getSalaryById = async (id, token) => {
  return await mainCaller(`admin/api/v1/employees/${id}/salaries`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

export const deleteSalaryById = async (id, token) => {
  return await mainCaller(`admin/api/v1/employees/${id}/salaries`, 'DELETE', null, {
    Authorization: 'Bearer ' + token,
  });
};